const discounts = [...document.querySelectorAll('.planet-volume-layout')];

if (discounts.length > 0) {
  const discountItems = [...discounts[1].querySelectorAll('.planet-volume-volumeItem')];
    discountItems.map(discountItem => {
        discountItem.addEventListener('click', (e) => {
            const quantityText = discountItem.querySelector('.planet-volume-label').innerText;
            const quantityNumber = parseInt(quantityText.match(/(\d+)/)[1]);
            const select = document.querySelector('.js-pdp-order-desktop').querySelector('.js-order-select');

            select.value = quantityNumber;
        })
    });
}
